<template>
  <app-modal v-model="isDialogOpened"
             size="md"
             :ok-text="$t('projects.ProjectsDataroomContactForm.sendRequest')"
             :ok-loading="contactFormRequestPending"
             :cancel-disabled="contactFormRequestPending"
             data-locator="subscription-change-offer-dialog"
             @cancel="closeDialog"
             @ok="onOkClick"
  >
    <template #title>
      <span class="text--large text--extra-bold">{{ $t(`${TRANSLATION_KEY_PREFIX}.title`) }}</span>
    </template>

    <template #body>
      <p class="text-text-secondary mb-4">{{ $t(`${TRANSLATION_KEY_PREFIX}.subtitle`) }}</p>

      <ProjectsDataroomContactForm ref="contactForm"
                                   @formSubmitSuccess="onContactFormSubmitSuccess"
      />
    </template>
  </app-modal>
</template>

<script>
  import { toast } from '@/common/utils/toast'
  import { dialogMixin } from '@/mixins/dialogMixin'
  import ProjectsDataroomContactForm from '@/projects/ProjectsDataroomContactForm.vue'

  const TRANSLATION_KEY_PREFIX = 'subscriptions.views.SubscriptionConsumption.ChangeOfferDialog'

  export default {
    name: 'SubscriptionConsumptionChangeOfferDialog',
    components: { ProjectsDataroomContactForm },
    mixins: [dialogMixin],
    data () {
      return {
        TRANSLATION_KEY_PREFIX,
        contactFormRequestPending: false,
      }
    },
    methods: {
      async onOkClick () {
        const isContactFormValid = await this.$refs.contactForm.sendRequest()
        if (isContactFormValid) {
          this.contactFormRequestPending = true
        }
      },
      onContactFormSubmitSuccess () {
        this.contactFormRequestPending = false
        toast.success(this.$t('projects.dialogs.ProjectTypeQuoteRequestDialog.quoteRequestSuccessMessage'))
        this.closeDialog()
      },
    },
  }
</script>
